<template>
  <section class="contato">
    <!-- Titulo -->
    <div class="titulo">
      <div class="icone">
        <Svgs nome="cursor" />
      </div>
      <div class="texto">
        <h3>Precisa de ajuda para escolher seu plano?</h3>
        <p>Nossa equipe de especialistas está pronta para te auxiliar tirando dúvidas e direcionando o melhor plano para sua necessidade.</p>
      </div>
    </div>
  </section>
</template>

<script setup>
import Svgs from '@svgs'
</script>

<style scoped>
section.contato {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 0 0 0;
  width: 100%;
}
.titulo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px 40px 20px 20px;
  background-color: var(--cor-escuro-2);
  border-radius: 10px;
}
.titulo .icone {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 10px;
  background-color: var(--cor-escuro-3);
}
.titulo .icone svg {
  width: 20px;
  min-width: 20px;
  fill: var(--cor-branco);
}
.titulo .texto {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: auto;
  padding: 0 0 0 15px;
}
.titulo .texto h3 {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-branco);
}
.titulo .texto p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  margin: 5px 0 0 0;
  width: 100%;
}
.titulo a {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--cor-marca);
  font-family: var(--medium);
  font-size: var(--f2);
  color: var(--cor-branco);
  padding: 12px 20px;
  border-radius: 8px;
  transition: all 0.3s;
}
.titulo a:hover {
  background-color: var(--cor-marca-escuro);
}
/* Responsivo */
@media screen and (max-width: 1024px) {
  section.contato {
    padding: 15px 20px 20px 20px;
  }
  .titulo {
    flex-direction: column;
    justify-content: center;
    padding: 40px 20px;
  }
  .titulo .icone {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 10px;
    background-color: var(--cor-escuro-3);
  }
  .titulo .icone svg {
    width: 20px;
    min-width: 20px;
    fill: var(--cor-branco);
  }
  .titulo .texto {
    align-items: center;
    text-align: center;
    margin-right: 0;
    padding: 20px 0 0 0;
  }
  .titulo .texto h3 {
    width: 100%;
    max-width: 180px;
    line-height: 1.5;
  }
  .titulo .texto p {
    line-height: 1.5;
    margin: 5px 0 15px 0;
    width: 100%;
    max-width: 230px;
    line-height: 1.5;
  }
  .titulo a {
    font-size: var(--f1);
    padding: 10px 16px;
    border-radius: 8px;
  }
}
</style>
